import React from 'react'
import { FaUsers } from "react-icons/fa6";
import { FaCar, FaClock } from "react-icons/fa";
import { FaAward } from "react-icons/fa";
import { Helmet } from "react-helmet";



const Numbers = () => {
    const data = [
        {
            id: 0,
            icon: <FaCar size={25} className='text-pink-600' />,
            number: "100+",
            title: "Cabs Available"
        },
        {
            id: 1,
            icon: <FaUsers size={25} className='text-pink-600' />,
            number: "10,000+",
            title: "Happy Travelers"
        },
        {
            id: 2,
            icon: <FaClock size={22} className='text-pink-600' />,
            number: "24/7",
            title: "Service Available"
        },
        {
            id: 3,
            icon: <FaAward size={23} className='text-pink-600' />,
            number: "12+",
            title: "Years Of Expertise"
        }
    ]
    return (
        <>
            <Helmet>
                <title>The Best Cab Jaipur – Affordable Taxi, One Way & Outstation Services</title>
                <meta
                    name="description"
                    content="Book reliable and affordable cab services in Jaipur for one-way, round trips, and outstation travel. Explore Rajasthan’s top destinations with our trusted taxi service and tour packages."
                />
                <meta
                    name="keywords"
                    content="Jaipur cab service, one way taxi, round trip taxi, outstation travel, affordable taxi, Rajasthan tours, taxi booking Jaipur"
                />
                <meta name="author" content="The Best Cab Jaipur" />
            </Helmet>
            <section className="container px-6 py-8 mx-auto">
                <div className="grid grid-cols-1 gap-6 my-10 px-8 lg:grid-cols-4">
                    {data.map((item, index) => (
                        <div
                            key={index}
                            className="flex items-center p-6 bg-white border-2 border-gray-200 rounded-xl shadow-md hover:shadow-lg hover:border-pink-500 transition-all duration-300 transform hover:scale-105"
                        >
                            <div className="p-4 mr-4 bg-pink-300 text-white shadow-md rounded-full">
                                {item.icon}
                            </div>
                            <div className="px-4">
                                <p className="mb-1 text-4xl font-bold text-gray-900">{item.number}</p>
                                <p className="text-sm font-medium text-gray-600">{item.title}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </>

    )
}

export default Numbers